import React from "react";
import { AssessmentAiPanel } from "./AssessmentAiPanel";

/**
 * Thin route wrapper for AssessmentAiPanel.
 *
 * AssessmentAiPanel requires an `assessmentTitle` prop, which BaseRoute cannot
 * pass directly. This wrapper supplies a placeholder title for the mock preview.
 *
 * TODO [VER-55]: read the real assessment title from the assessment record
 * (via the :assessmentId route param) once the backend is wired.
 */
export const AssessmentAiRoute = (): JSX.Element => {
    return <AssessmentAiPanel assessmentTitle="Assessment (preview)" />;
};

export default AssessmentAiRoute;
